import { z } from "zod";
import { CampaignStatusSchema } from "./campaign";

export const campaignStateParamsSchema = z.object({
  id: z.string().uuid(),
});
export type CampaignStateParams = z.infer<typeof campaignStateParamsSchema>;

export const campaignStateUpdateSchema = z.object({
  state: CampaignStatusSchema,
});
export type CampaignStateUpdate = z.infer<typeof campaignStateUpdateSchema>;

export const campaignStateUpdateResponseSchema = z.object({
  campaignId: z.string().uuid(),
  previousState: CampaignStatusSchema,
  state: CampaignStatusSchema,
  changed: z.boolean(),
  pending: z.boolean().optional(),
  controlRequestId: z.string().uuid().optional(),
  syncedAt: z.string().datetime(),
});
export type CampaignStateUpdateResponse = z.infer<typeof campaignStateUpdateResponseSchema>;
